/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "danielduran.dev",
  title: "Hi all, I'm Daniel",
  subTitle: emoji(
    "Professional web developer with 2 years of experience in frontend (Angular and React) and backend (Node.js, Java, Spring) technologies. Ready to advance my career in innovative companies. I possess a particular curiosity about AI and product management. A quick learner with sharp problem-solving and communication skills, honed through rigorous coursework and international experiences.\n"
  ),
  resumeLink:
    "https://danieldurandev-assets.s3.eu-south-2.amazonaws.com/Daniel_Duran_Resume_EN_Public.pdf", // Set to empty to hide the button
  displayGreeting: true, // Set false to hide this section, defaults to true,
  contactMe: "Contact me",
  downloadMyResume: "Download my resume"
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/danielduri",
  linkedin: "https://www.linkedin.com/in/danielduranr/",
  gmail: "hello@danielduran.dev",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  linkName: "Skills",
  title: "What I do",
  subTitle: "I'M SKILLED IN THESE TECHNOLOGIES, BUT I'M ALWAYS LOOKING TO LEARN MORE!",
  subTitle2: "I'M LOOKING TO EXPAND MY KNOWLEDGE IN",
  skills: [
    emoji(
      "⚡ Work seamlessly across frontend and backend, from designing intuitive user interfaces to implementing scalable server-side logic"
    ),
    emoji(
      "⚡ Translate business goals into impactful products by integrating APIs and services that deliver real value to users"
    ),
    emoji(
      "⚡ Collaborate with cross-functional teams to deliver high-quality software solutions that meet business needs and user expectations"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Spring",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    }
  ],
  otherSkills: [
      {
    skillName: "Product Management",
    fontAwesomeClassname: "fas fa-flag-checkered"
  },
  {
    skillName: "Artificial Intelligence",
    fontAwesomeClassname: "fas fa-robot"
  },
    {
      skillName: "Mobile Development",
        fontAwesomeClassname: "fas fa-mobile-alt"
    },
    {
      skillName: "Talks and Events",
      fontAwesomeClassname: "fas fa-comments"
    }
    ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  linkName: "Education",
  display: true, // Set false to hide this section, defaults to true
  sectionTitle: "Education",
  schools: [
    {
      schoolName: "Universidad Complutense de Madrid",
      logo: require("./assets/images/ucmLogo.png"),
      subHeader: "Computer Engineering and Business Administration - Double Major Program",
      duration: "September 2017 - May 2023",
      desc: "Final project: Developed an application for course guide management using Microsoft Azure AI and OpenAI GPT. Grade: 9.5/10.",
      descBullets: [
        "Other projects: Physics Simulator [Java], Plants vs. Zombies clone [Java], WordPress eShop, event management application [Java], videogame course platform [HTML+CSS+PHP]",
        "Technical: Data Structures and Algorithms, Operating Systems, Computer Architecture, Software Engineering, Computer Networks, Network Security, Human-Computer Interaction",
        "Business: Finance and economics, Accounting, Operations, Marketing, Product, Strategy, Innovation, Legislation, Human Resources"
      ]
    },
    {
      schoolName: "Fundación Amancio Ortega",
      logo: require("./assets/images/fundacin_amancio_ortega_logo.jpeg"),
      subHeader: "Year Abroad Program - Hutchinson, KS, USA",
      duration: "August 2015 - May 2016",
      desc: "Selected among thousands of students for a prestigious scholarship to complete a school year in the US, recognizing academic excellence and leadership potential.",
      descBullets: ["Connected with peers from various countries and engaged with different cultures.",
        "Handpicked by program staff from former recipients to serve as Program Ambassador.",
        "Supported 500+ new scholars by leading orientation workshops, cultural exchange events, and peer mentoring to foster successful adaptation. Led group activities that promoted community building and cultural understanding, significantly increasing participant engagement"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  linkName: "Experience",
  display: true, //Set it to true to show workExperiences Section
  sectionTitle: "Experience",
  experience: [
    {
      role: "Product Software Engineer",
      company: "Swiss Re",
      companylogo: require("./assets/images/swissRelogo.jpg"),
      date: "May 2025 – Present",
      desc: "Build and maintain the company’s core Policy service, a central component in a large microservices-based insurance platform with over 30,000 active policies, built with Java Spring and Docker.",
      descBullets: [
        "Piloted development of a new Medical Invoice Management system and comprehensive audit log for user actions, driving early-stage design and implementation to improve operational efficiency and compliance.",
        "Collaborate with product managers and engineers to align technical features with business objectives.",
        "Leverage automated testing, feature flags, and CI/CD to ensure high-quality releases.",
      ]
    },
    {
      role: "Software Engineer",
      company: "Indra Deimos",
      companylogo: require("./assets/images/deimosLogo.png"),
      date: "March 2023 – May 2025",
      desc: "Developed, deployed and tested frontend and backend solutions for several clients. Drafted technical documents.",
      descBullets: [
        "Designed and implemented the frontend for an eHealth project at a prominent public hospital.",
        "Integrated Fitbit smart bands through their API.",
        "Contributed to the evolution of several modules in a process management application for a large infrastructure company, to enhanced user satisfaction.",
        "Spearheaded the adoption of GitHub Copilot across the company’s development teams by leading workshops for 20+ engineers, boosting developer satisfaction and productivity."
      ]
    },
    {
      role: "Product Management Intern",
      company: "Dost",
      companylogo: require("./assets/images/dostLogo.png"),
      date: "December 2022 – March 2023",
      desc: "Facilitated contact between clients and a multicultural product team, ensuring efficient resolution of bugs and addressing client requests promptly.",
      descBullets: [
        "Conducted user interviews and surveys to identify user needs and preferences.",
        "Helped users navigate the platform and provided technical support.",
        "Increased client satisfaction by addressing their concerns and providing timely solutions."
      ]
    },
    {
      role: "Identity Access Management Intern",
      company: "Bankinter",
      companylogo: require("./assets/images/bkLogo.png"),
      date: "January 2022 – July 2022",
      desc: "Managed the identities of 6,000+ bank employees and 10,000+ external contractors, providing them with appropriate access to company resources and shared folders.",
        descBullets: [
            "Collaborated with the cybersecurity team to ensure compliance with the bank's security policies.",
            "Adhered to financial industry best practices by verifying authorizations for each access request and recording an auditable trace, fostering a culture of security and accountability across the organization.",
        ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  linkName: "Open Source",
  showGithubProfile: false, // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  linkName: "Projects",
  title: "Projects",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/syllabusLogo.png"),
      projectName: "SyllabusCentral",
      projectDesc: "AI-powered course guide management application",
      footerLink: [
        {
          name: "Watch demo",
          url: "https://drive.google.com/file/d/1KLfY3WlP6Vz_KFfw-OtNJuZElOl3kfgu/view"
        },
        {
            name: "Read report (spanish)",
            url: "https://danieldurandev-assets.s3.eu-south-2.amazonaws.com/Daniel_Duran_Final_Project_CS.pdf"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/psLogo.jpeg"),
      projectName: "PlayStation Brand Analysis",
      projectDesc: "Business Administration project analyzing the evolution of the PlayStation brand",
      footerLink: [
        {
          name: "Read (spanish)",
          url: "https://danieldurandev-assets.s3.eu-south-2.amazonaws.com/Daniel_Duran_Final_Project_BA.pdf"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  linkName: "Certifications",
  title: emoji("Certifications"),
  subtitle: "",

  achievementsCards: [
    {
      title: "Google Cloud - Professional Data Engineer",
      subtitle:
          "November 2022",
      image: require("./assets/images/PDEbadge.png"),
      footerLink: [
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/512db318-2a87-49a0-9321-125a6c721f6d/public_url"
        }
      ]
    },
    {
      title: "Google Cloud - Associate Cloud Engineer",
      subtitle:
        "August 2022",
      image: require("./assets/images/ACEbadge.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certificate",
          url: "https://www.credly.com/badges/c2235f3f-a60b-4409-a26b-c36fd9b8fb97/public_url"
        }
      ]
    },
    {
      title: "Google Project Management Certificate",
      subtitle: "August 2021",
      image: require("./assets/images/GPMbadge.png"),
      footerLink: [
        {name: "Certificate", url: "https://www.credly.com/badges/7c5025f1-c70a-41cb-a3e5-b6a2b30fa6fd/public_url"},
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  linkName: "Blogs",
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  linkName: "Talks",
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  linkName: "Podcast",
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  linkName: "Contact Me",
  title: emoji("Wanna talk? 🤙🏽"),
  subtitle:
    "My inbox and DMs are always open. Let's meet for coffee!",
  email_address: "hello@danielduran.dev"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

// Footer Section
const footerSection = {
  text: emoji("Made with ❤️ from 40.416729, -3.703339"),
  themeBy: "Theme by",
  themeLink: "https://github.com/saadpasta/developerFolio",
  themeName: "developerFolio",
  thanks: "(thanks! :D)"
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  footerSection
};
